import { sendFormAsAjax } from './functions';

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".integration-page")) {
        const markDone = function (button, done) {
            if (!button) {
                return;
            }
            button.classList.toggle('btn-outline-success', done);
            button.classList.toggle('btn-outline-primary', !done);
        };

        // Save buttons turn green only once the server confirmed the save (not on click,
        // which also showed the check when the request failed).
        [['save-zapier-secret', 'btn-save-secret'], ['save-zapier-signals-webhook-url', 'btn-save-signals-webhook-url']].forEach(([formId, buttonId]) => {
            const form = document.getElementById(formId);
            if (!form) {
                return;
            }
            form.addEventListener('submit', function (event) {
                event.preventDefault();

                const button = document.getElementById(buttonId);
                markDone(button, false);
                sendFormAsAjax(this, 'PATCH', null, function () {
                    markDone(button, true);
                });
            });
        });

        // Generate and Copy act locally, so they confirm on click. A new key is not
        // saved yet, so Save drops back to its unsaved look (and the page's nudge).
        ['btn-generate-secret', 'btn-copy-secret'].forEach(id => {
            const btn = document.getElementById(id);
            if (btn) {
                btn.addEventListener('click', function () {
                    markDone(this, true);
                    if (id === 'btn-generate-secret') {
                        markDone(document.getElementById('btn-save-secret'), false);
                    }
                });
            }
        });
    }
});
